import * as React from 'react';
import './Aside.styles.scss';

export interface AsideProps extends React.HTMLAttributes<HTMLDivElement> {
  type: 'pink' | 'note' | 'quote' | 'warning' | 'error';
  title: string;
}

export const Aside = ({ type = 'note', title, ...props }: AsideProps) => {
  return (
    <div
      className={`aside ${type}`}
      style={{ padding: title ? '15px 25px' : '30px 25px' }}
      {...props}>
      {title ? <h5>{title}</h5> : null}
      {props.children}
    </div>
  );
};
